import { DEL_CLMUNREL_INIT_LOADING, DEL_CLMUNREL_INIT_SUCCESS, DEL_CLMUNREL_INIT_FAIL, DEL_CLMUNREL_SEL_DATA } from '@/store/types'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import clone from 'clone'

export const initiateState = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {},
  sel: {
    branch: '',
    fund: '',
    tranType1: '',
    docNo: ''
  }

}

export const getters = {

}

export const mutations = {
  [DEL_CLMUNREL_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [DEL_CLMUNREL_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data ? data.menu : null
    state.initErr = []
  },
  [DEL_CLMUNREL_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  },
  [DEL_CLMUNREL_SEL_DATA](state, sel) {
    state.sel.branch = sel.branch
    state.sel.fund = sel.fund
    state.sel.tranType1 = sel.tranType1
    state.sel.docNo = sel.docNo
  }
}

const actions = {
  async clmUnrelDelInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.deleteUnrelClaimsTxnManagement
    commit(DEL_CLMUNREL_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu
        }
        commit(DEL_CLMUNREL_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(DEL_CLMUNREL_INIT_FAIL, extractMessages(error))
      }
    }
  }
}

export default {
  state: clone(initiateState),
  getters,
  mutations,
  actions
}
